import { render } from "./SudokuBlock.vue?vue&type=template&id=aaa3e3fe&scoped=true"
import script from "./SudokuBlock.vue?vue&type=script&lang=js"
export * from "./SudokuBlock.vue?vue&type=script&lang=js"

import "./SudokuBlock.vue?vue&type=style&index=0&id=aaa3e3fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaa3e3fe"]])

export default __exports__